module.exports = __webpack_public_path__ + "Group 15696.b540e1755b1a1a6d9bd6.png";